/*
 * View for the performance tab on the Topic page
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicPerformance/template/topicPerformanceTemplate.html",
], function (Marionette, TopicPerformanceTemplate) {
  var TopicPerformanceView = {};

  TopicPerformanceView.topicPerformanceLayout = Marionette.Layout.extend({
    template: TopicPerformanceTemplate,
    modelEvents: {
      sync: "setAccuracy",
    },
    regions: {
      accuracyChart: "#accuracyChart",
      trendingChart: "#trendingChart",
    },
    setAccuracy: function () {
      var accuracy = this.model.get("amount");
      this.$el.find("#accuracyValue").html(accuracy);
      //change the color of the background based on the accuracy score
      var rgb = "rgb(";
      if (accuracy <= 50) {
        rgb += "200, 0, 0)";
      } else if (accuracy <= 75) {
        rgb += "200, " + 200 * ((accuracy - 50) / 25) + ", 0)";
      } else {
        rgb += 200 * ((100 - accuracy) / 25) + ", 200, 0)";
      }
      this.$el.find("#accuracyValue").css("background-color", rgb);
    },
  });

  return TopicPerformanceView;
});
